export class EntityValidationErrorResponse {
  name: any;
  code: any;
  fiscalYearEnd: any;
  description: any;
  // default validation errors
  'primaryFunction.primaryFunctionId': any;
  'domicile.countryId': any;
  'taxJurisdiction.countryId': any;
}
